var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"size":"xl","id":"history-offer-model","centered":true}},[_c('b-container',{attrs:{"fluid":""}},[_c('offer-list',{attrs:{"propsParams":{customer_id: this.id}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }